export const INCLUDE_PERSONAL_ANNOUNCEMENTS = false;

export function getPrivacyProfile(showsMessagesPanel = false) {
  const hasMessageAccess = showsMessagesPanel === true;
  return {
    mode: hasMessageAccess ? 'internal' : 'external',
    showsMessagesPanel: hasMessageAccess,
    includesPersonalAnnouncements: hasMessageAccess
  };
}
